import api from "./Api";

class LocalPedidoService {
  GetLocalPedido(payload) {
    return api.get("/v1/localPedido/" + payload).then((response) => {
      return response.data;
    });
  }

  PostLocalPedido(payload) {
    return api.post("/v1/localPedido/", payload).then((response) => {
      return response.data;
    });
  }

  PutLocalPedido(payload) {
    return api.put("/v1/localPedido/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteLocalPedido(payload) {
    return api.delete("/v1/localPedido/" + payload).then((response) => {
      return response.data;
    });
  }

  GetLocalPedidoOData(payload) {
    return api.get("/OData/LocalPedido" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new LocalPedidoService();
